import { apiClient } from "@/lib/api-client";
import type { ApiResponse } from "@/types/api";
import type {
  CreateUserRequest,
  CreateUserResponse,
  ResetPasswordResponse,
  UpdateUserRequest,
  UserListItem,
} from "../types";

export async function listUsers(): Promise<UserListItem[]> {
  const response = await apiClient.get<ApiResponse<UserListItem[]>>("/users");
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error(response.data.message || "Failed to load users");
}

export async function createUser(
  data: CreateUserRequest,
): Promise<CreateUserResponse> {
  const response = await apiClient.post<ApiResponse<CreateUserResponse>>(
    "/users",
    data,
  );
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error(response.data.message || "Failed to create user");
}

export async function updateUser(
  id: string,
  data: UpdateUserRequest,
): Promise<void> {
  const response = await apiClient.put<ApiResponse<null>>(`/users/${id}`, data);
  if (!response.data.success) {
    throw new Error(response.data.message || "Failed to update user");
  }
}

export async function deactivateUser(id: string): Promise<void> {
  const response = await apiClient.post<ApiResponse<null>>(
    `/users/${id}/deactivate`,
  );
  if (!response.data.success) {
    throw new Error(response.data.message || "Failed to deactivate user");
  }
}

export async function reactivateUser(id: string): Promise<void> {
  const response = await apiClient.post<ApiResponse<null>>(
    `/users/${id}/reactivate`,
  );
  if (!response.data.success) {
    throw new Error(response.data.message || "Failed to reactivate user");
  }
}

export async function resetUserPassword(
  id: string,
): Promise<ResetPasswordResponse> {
  const response = await apiClient.post<ApiResponse<ResetPasswordResponse>>(
    `/users/${id}/reset-password`,
  );
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error(response.data.message || "Failed to reset password");
}
